import {app} from '../../app';
import IScope = angular.IScope;
import IComponentController = angular.IComponentController;
import {TextQuestionPreviewComponent} from "./TextQuestionPreviewComponent";

export class EmailQuestionPreviewComponent extends TextQuestionPreviewComponent {

}

app.component('emailQuestionPreview', {
    templateUrl : 'templates/components/questionPreviews/textQuestionPreview.html',
    controller  : EmailQuestionPreviewComponent,
    controllerAs: 'textQuestionPreview',
    bindings    : {
        question: '<'
    }
});